import { PreactRenderer, Shark } from "shark-mvc";
import moment from "moment";

import { NousCore } from "nouscore-js-api";
import { homeView } from "./_shark_jaws/views/homeView";
import loginView from "./views/login/loginView";
import systemManager from "./_shark_jaws/managers/systemManager";

import "./js/sejda-js-api.min.js";
import "jquery";
import "popper.js";

import "./_shark_models/Client";
import "./_shark_models/Document";
import "./_shark_models/ProductLine";
import "./_shark_models/User";
import "./_shark_models/Visit";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/custom_old.css";
import "./css/custom-fonts.css";
import "./css/custom.css";
import "./css/desktop.css";
import "./css/print.css";

import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faHourglass } from "@fortawesome/free-solid-svg-icons/faHourglass";
import { faPaste } from "@fortawesome/free-solid-svg-icons/faPaste";
library.add(faChevronLeft, faChevronRight, faHourglass, faPaste);
dom.watch();

const agentAppURL = "https://agenti.ipmitalia.it";
const extranetURL = "https://hub.ipmitalia.it";
const serverURL = process.env.CDN_URL;// "https://hub.ipmitalia.it";// 

NousCore.api.settings.commonEndPointBase = serverURL + "/api/";//process.env.API_URL;//

Shark.traceLevel = Shark.TRACE_INFO;

Shark.init({
	enableMainStoreAutoRender: true,
	enableSmartModelSetUpdatesView: true,
	// enableJawsCompatibilityMode: true,
	// templateRenderer: new PreactRenderer(),
});

moment.locale("it");

console.log("guid:", Shark.__generateGUID());

const clientActivityStatusList = [
	{id: 0, label: "Non impostato"},
	{id: 1, label: "In attesa"},
	{id: 4, label: "Compilato report"},
	{id: 5, label: "Preventivo in attesa"},
	{id: 6, label: "Preventivo accettato"},
	{id: 7, label: "Preventivo rifiutato"},
	{id: 8, label: "Diventato Cliente"},
	{id: 9, label: "Non interessato"},
	{id: 11, label: "Creata Scheda Informativa"},
];
const clientActivityStatusMap = {};
clientActivityStatusList.forEach(item => clientActivityStatusMap[item.id] = item.label);

const constructionSiteStatusList = [
	{id: 1, label: "Cantiere in corso"},
	{id: 2, label: "Cantiere chiuso"},
	{id: 3, label: "Cantiere concluso senza problemi"},
	{id: 4, label: "Cantiere concluso con non conformità"},
	{id: 5, label: "Cantiere chiuso con non conformità"},
	{id: 6, label: "Cantiere NC in corso"},
	{id: 7, label: "Cantiere NC chiuso"},
	{id: 8, label: "Cantiere NC concluso"},
];
const constructionSiteStatusMap = {};
constructionSiteStatusList.forEach(item => constructionSiteStatusMap[item.id] = item.label);

const constructionSiteCardStatusList = [
	{id: 1, label: "In attesa"},
	{id: 5, label: "Pronto a partire"},
	{id: 2, label: "Cantiere in corso"},
	{id: 3, label: "Cantiere concluso senza problemi"},
	{id: 4, label: "Cantiere concluso con non conformità"},
];
const constructionSiteCardStatusMap = {};
constructionSiteCardStatusList.forEach(item => constructionSiteCardStatusMap[item.id] = item.label);

const contactSourceList = [
	{ id: 1, disabled: "", label: "Propria ricerca", tags: [] },
	{ id: 3, disabled: "", label: "Azioni di marketing", tags: ["marketing-lead"] },
	{ id: 2, disabled: "", label: "Fiere", tags: ["marketing-lead"] },
	{ id: 5, disabled: "", label: "Altro", tags: ["marketing-lead"] },
	{ id: 7, disabled: "", label: "Già cliente", tags: ["marketing-lead"] },
	{ id: 8, disabled: "disabled", label: "Sito", tags: ["marketing-lead"] },
	{ id: 9, disabled: "disabled", label: "Mail commerciale", tags: ["marketing-lead"] },
	{ id: 10, disabled: "disabled", label: "Numero Verde", tags: ["marketing-lead"] },
	{ id: 11, disabled: "disabled", label: "SMM", tags: ["marketing-lead"] },
	{ id: 12, disabled: "disabled", label: "Segnalazione", tags: ["marketing-lead"] },
	{ id: 13, disabled: "disabled", label: "Landing", tags: ["marketing-lead"] },
];
const contactSourceMap = {};
contactSourceList.forEach(item => contactSourceMap[item.id] = item.label);

const contactSourceDetailList = [
	{ id: 1, contactSourceId: 9, disabled: "", label: "commerciale@ipmitalia.it" },
	{ id: 2, contactSourceId: 9, disabled: "", label: "mail commerciale" },
	{ id: 3, contactSourceId: 8, disabled: "", label: "Hub spot" },
	{ id: 4, contactSourceId: 8, disabled: "", label: "ADS" },
	{ id: 5, contactSourceId: 8, disabled: "", label: "DIRECT" },
	{ id: 6, contactSourceId: 8, disabled: "", label: "PAID" },
	{ id: 7, contactSourceId: 10, disabled: "", label: "Numero Verde" },
	{ id: 8, contactSourceId: 10, disabled: "", label: "n°verde" },
	{ id: 9, contactSourceId: 3, disabled: "", label: "MAIL CHIMP" },
	{ id: 10, contactSourceId: 3, disabled: "", label: "EDILPORTALE" },
	{ id: 11, contactSourceId: 3, disabled: "", label: "DEM EDILPORTALE" },
	{ id: 12, contactSourceId: 3, disabled: "", label: "Pysage" },
	{ id: 13, contactSourceId: 2, disabled: "", label: "Fiere" },
	{ id: 14, contactSourceId: 2, disabled: "", label: "Simei" },
	{ id: 15, contactSourceId: 2, disabled: "", label: "Enolitech" },
	{ id: 16, contactSourceId: 2, disabled: "", label: "MyPlant" },
	{ id: 17, contactSourceId: 3, disabled: "", label: "NiiProgetti" },
];
const contactSourceDetailMap = {};
contactSourceDetailList.forEach(item => contactSourceDetailMap[item.id] = item.label);
const contactSourceDetailLabelMap = {};
contactSourceDetailList.forEach(item => contactSourceDetailLabelMap[item.label.toLowerCase()] = item);

const followUpReferenceList = [
	{ id: "appointment", label: "Appuntamento"},
	{ id: "attachment", label: "Allegato" },
	{ id: "client", label: "Scheda Cliente" },
	{ id: "clientVisit", label: "Report" },
	{ id: "constructionSite", label: "Cantiere" },
	{ id: "constructionSiteCard", label: "Scheda Cantiere" },
	{ id: "notComplianceReport", label: "Non Conformità"},
	{ id: "quotation", label: "Preventivo" },
	{ id: "report", label: "Report" },
	{ id: "sampleRequest", label: "Richiesta Campionatura"},
	{ id: "siteInfoSheet", label: "Scheda Informativa" },
	{ id: "visit", label: "Report" },
];
const followUpReferenceMap = {};
followUpReferenceList.forEach(item => followUpReferenceMap[item.id] = item.label);

const followUpTypeList = [
	{ enabled: true, id: "note", label: "Nota generica"},
	{ enabled: true, id: "phoneCall", label: "Telefonata"},
	{ enabled: true, id: "eMail", label: "eMail"},
	{ enabled: true, id: "visit", label: "Visita"},
	{ enabled: true, id: "message", label: "Altra messaggistica"},
	{ enabled: true, id: "constructionSiteProblem", label: "Problema in cantiere"},
	{ enabled: true, id: "leadIncomingMessage", label: "Prima richiesta"},
];
const followUpTypeMap = {};
followUpTypeList.forEach(item => followUpTypeMap[item.id] = item.label);

const interestedInList = [
	{ id: 1, label: "Pavimenti in resina"},
	{ id: 2, label: "Riqualificazione Pavimenti"},
	{ id: 3, label: "Pavimenti in Calcestruzzo"},
	{ id: 4, label: "Pavimentazione drenante in graniglia"},
	{ id: 5, label: "Pavimentazioni per aree ludiche e sportive"},
	{ id: 6, label: "Prodotti per il trattamento di strade naturali"},
	{ id: 7, label: "Pavimentazioni per la marina"},
];
const interestedInMap = {};
interestedInList.forEach(item => interestedInMap[item.id] = item.label);

const notComplianceReportStatusList = [
	{id: 0, label: "Non impostato"},
	{id: 1, label: "Aperta"},
	{id: 2, label: "Completa"},
	{id: 3, label: "Conclusa"},
	{id: 4, label: "In attesa di CCA/FLC"},
	{id: 5, label: "Pronta per partenza cantiere"},
	{id: 6, label: "Cantiere in corso"},
];
const notComplianceReportStatusMap = {};
notComplianceReportStatusList.forEach(item => notComplianceReportStatusMap[item.id] = item.label);

const notComplianceReportInvoicingStatusList = [
	{id: 0, label: "In attesa di verifica"},
	{id: 1, label: "Fatturazione completa"},
	{id: 2, label: "Fatturazione parziale"},
	{id: 3, label: "Non fatturato"},
];
const notComplianceReportInvoicingStatusMap = {};
notComplianceReportInvoicingStatusList.forEach(item => notComplianceReportInvoicingStatusMap[item.id] = item.label);

const notComplianceReportPaymentStatusList = [
	{id: 0, label: "In attesa di verifica"},
	{id: 1, label: "Concluso"},
	{id: 2, label: "In corso"},
	{id: 3, label: "In ritardo"},
	{id: 4, label: "Bloccato"},
];
const notComplianceReportPaymentStatusMap = {};
notComplianceReportPaymentStatusList.forEach(item => notComplianceReportPaymentStatusMap[item.id] = item.label);

const quotationStatusList = [
	{id: 0, label: "In attesa"},
	{id: 1, label: "In attesa di riscontro"},
	{id: 2, label: "Accettato"},
	{id: 3, label: "Rifiutato"},
	{id: 4, label: "Caricato per l'agente"},
	{id: 5, label: "Creata Scheda Cantiere"},
	{id: 6, label: "Create Schede Cantiere"},
	{id: 7, label: "Cantiere concluso"},
	{id: 8, label: "Sostituito per revisione"},
	{id: 10, label: "Cantieri con stati diversi"},
	{id: 11, label: "Cantieri in corso"},
	{id: 12, label: "Scheda Cantiere in corso"},
];
const quotationStatusMap = {};
quotationStatusList.forEach(item => quotationStatusMap[item.id] = item.label);

const reportStatusList = [
	{id: 0, label: "Non impostato"},
	{id: 1, label: "Da sviluppare"},
	{id: 2, label: "In gestione"},
	{id: 3, label: "Concluso Positivamente"},
	{id: 4, label: "Concluso Negativamente"},
	{id: 5, label: "Non interessato"},
	{id: 6, label: "Non raggiungibile"},
];
const reportStatusMap = {};
reportStatusList.forEach(item => reportStatusMap[item.id] = item.label);

const siteInfoSheetQuotationStatusList = [
	{id: 0, label: "In attesa"},
	{id: 4, label: "In attesa di riscontro da agente"},
	{id: 1, label: "Inviato"},
	{id: 2, label: "Accettato"},
	{id: 3, label: "Rifiutato"},
];
const siteInfoSheetQuotationStatusMap = {};
siteInfoSheetQuotationStatusList.forEach(item => siteInfoSheetQuotationStatusMap[item.id] = item.label);


const systemIndustrialList = [
	{
		group: "SISTEMA PELLICOLARE",
		line: "ipmBasicLine",
		systems: [
			"IPM TEC MONO",
			"IPM COATING",
		]
	},
	{
		group: "SISTEMI MULTISTRATI",
		line: "ipmBasicLine",
		systems: [
			"IPM STRATOS",
			"IPM QCF",
			"IPM QCF RAPID",
			"IPM COLOR / MIX",
			"IPM COLOR / FLAKE",
			"IPM PROTECTO",
			"IPM MULTICRETE",
			"IPM MULTICRETE HD",
		]
	},
	{
		group: "SISTEMA AUTOLIVELLANTE",
		line: "ipmBasicLine",
		systems: [
			"IPM LEVELLING",
		]
	},
	{
		group: "SISTEMA NON CERTIFICATO",
		line: "ipmBasicLine",
		systems: [
			"MULTIRASO 2/3 R",
		]
	},
	{
		group: "SISTEMI ANTISTATICI E NORMATIZZATI ESD",
		line: "ipmBasicLine",
		systems: [
			"IPM VOLTEC",
			"IPM VOLTEC / COLORMIX",
			"IPM VOLTEC / PROTECTO",
			"IPM VOLTEC / BLINDO",
		]
	},
	{
		group: "SISTEMI POLIURETANICI",
		line: "ipmBasicLine",
		systems: [
			"IPM DURTEC",
			"IPM SILENTIA",
			"IPM ELASTO",
		]
	},
	{
		group: "SISTEMI DECORATIVI",
		line: "ipmBasicLine",
		systems: [
			"IPM CULT",
			"IPM FABRIKA",
			"IPM VENEXIAN",
		]
	},
	{
		group: "SISTEMA IN MALTA EPOSSIDICA AD ALTO SPESSORE",
		line: "ipmBasicLine",
		systems: [
			"IPM BLINDO",
			"IPM BLINDO / PLUS",
			"IPM BLINDO / OIL",
			"IPM BLINDO / MIX",
		]
	},
	{
		group: "SISTEMA IN MALTA SINTETICA",
		line: "ipmBasicLine",
		systems: [
			"IPM BLINDO MIX RAPID",
		]
	},
	{
		group: "SISTEMI PER PARCHEGGI",
		line: "ipmBasicLine",
		systems: [
			"IPM PARKING / OS8",
			"IPM PARKING / OS11A",
			"IPM PARKING / OS11 B",
		]
	},
	{
		group: "RIVESTIMENTI MURALI ANTICORROSIVI",
		line: "ipmWallCoating",
		systems: [
			"IPM AQUAPERM CERAMIX",
			"IPM CERAMIX HD",
		]
	},
	{
		group: "SISTEMI AQUAPERM TRASPIRANTI IMPREGNANTI E PELLICOLARI",
		line: "ipmBasicLine",
		systems: [
			"IPM AQUAPERM GLASS",
			"IPM AQUAPERM SEALER",
			"IPM AQUAPERM COATING",
		]
	},
	{
		// <option value="IPM AQUAPERM STRATOS">IPM AQUAPERM STRATOS (Sistema Traspirante Multistrato)</option>
		// <option value="IPM AQUAPERM DESIGN">IPM AQUAPERM DESIGN (Sistema Traspirante Multistrato)</option>
		// <option value="IPM AQUAPERM LEVELLING">IPM AQUAPERM LEVELLING (Sistema Autolivellante)</option>
		// <option value="IPM AQUAPERM BLINDO">IPM AQUAPERM BLINDO (Malta Epossidica ad Alto Spessore per Sottofondi Umidi)</option>

		group: "SISTEMI AQUAPERM TRASPIRANTI MULTISTRATO",
		line: "ipmAquapermLine",
		systems: [
			"IPM AQUAPERM STRATOS",
			"IPM AQUAPERM DESIGN",
		]
	},
	{
		group: "SISTEMA AQUAPERM AUTOLIVELLANTE",
		line: "ipmAquapermLine",
		systems: [
			"IPM AQUAPERM LEVELLING",
		]
	},
	{
		group: "SISTEMA AQUAPERM IN MALTA EPOSSIDICA AD ALTO SPESSORE PER SOTTOFONDI UMIDI",
		line: "ipmAquapermLine",
		systems: [
			"IPM AQUAPERM BLINDO",
		]
	},
	{
		group: "ALTRO",
		line: "ipmBasicLine",
		systems: [
			"ALTRO",
			"IPM FREETIME",
			"IPM ECONOMIE",
		]
	},
];

systemIndustrialList.forEach((group, groupIndex) => {
	group.groupIndex = groupIndex;

	group.systems = group.systems.map((system, systemIndex) => {
		return {
			index: systemIndex,
			label: system,
		};
	});
});



const systemProposalGroupList = [
	{id: -1, label: "N/D"},
	{id: 0, label: "Proposta consigliata"},
	{id: 1, label: "Proposta alternativa 1"},
	{id: 2, label: "Proposta alternativa 2"},
	{id: 3, label: "Proposta alternativa 3"},
	{id: 4, label: "Proposta alternativa 4"},
	{id: 5, label: "Proposta alternativa 5"},
];
const systemProposalGroupMap = {};
systemProposalGroupList.forEach(item => systemProposalGroupMap[item.id] = item.label);

const visitOutcomeList = [
	{id: "1", disabled: "", label: "Positivo"},
	{id: "future_v", disabled: "", label: "Visitare in futuro"},
	{id: "future_p", disabled: "", label: "Richiamare in futuro"},
	{id: "5", disabled: "", label: "Non interessato"},
	{id: "6", disabled: "", label: "Non raggiungibile"},
];

const visitOutcomeMap = {};
visitOutcomeList.forEach(item => visitOutcomeMap[item.id] = item.label);
visitOutcomeMap[0] = "Non impostato";

const visitStatusList = [
	{id: 0, label: "In gestione"},
	{id: 1, label: "Concluso"},
	{id: 2, label: "Non interessato"},
];
const visitStatusMap = {};
visitStatusList.forEach(item => visitStatusMap[item.id] = item.label);

const provinceList = [{ label: "AG" }, { label: "AL" }, { label: "AN" }, { label: "AO" }, { label: "AQ" }, { label: "AR" }, { label: "AP" }, { label: "AT" }, { label: "AV" }, { label: "BA" }, { label: "BT" }, { label: "BL" }, { label: "BN" }, { label: "BG" }, { label: "BI" }, { label: "BO" }, { label: "BZ" }, { label: "BS" }, { label: "BR" }, { label: "CA" }, { label: "CL" }, { label: "CB" }, { label: "CI" }, { label: "CE" }, { label: "CT" }, { label: "CZ" }, { label: "CH" }, { label: "CO" }, { label: "CS" }, { label: "CR" }, { label: "KR" }, { label: "CN" }, { label: "EN" }, { label: "FM" }, { label: "FE" }, { label: "FI" }, { label: "FG" }, { label: "FC" }, { label: "FR" }, { label: "GE" }, { label: "GO" }, { label: "GR" }, { label: "IM" }, { label: "IS" }, { label: "SP" }, { label: "LT" }, { label: "LE" }, { label: "LC" }, { label: "LI" }, { label: "LO" }, { label: "LU" }, { label: "MC" }, { label: "MN" }, { label: "MS" }, { label: "MT" }, { label: "VS" }, { label: "ME" }, { label: "MI" }, { label: "MO" }, { label: "MB" }, { label: "NA" }, { label: "NO" }, { label: "NU" }, { label: "OG" }, { label: "OT" }, { label: "OR" }, { label: "PD" }, { label: "PA" }, { label: "PR" }, { label: "PV" }, { label: "PG" }, { label: "PU" }, { label: "PE" }, { label: "PC" }, { label: "PI" }, { label: "PT" }, { label: "PN" }, { label: "PZ" }, { label: "PO" }, { label: "RG" }, { label: "RA" }, { label: "RC" }, { label: "RE" }, { label: "RI" }, { label: "RN" }, { label: "RM" }, { label: "RO" }, { label: "SA" }, { label: "SS" }, { label: "SV" }, { label: "SI" }, { label: "SR" }, { label: "SO" }, { label: "TA" }, { label: "TE" }, { label: "TR" }, { label: "TO" }, { label: "TP" }, { label: "TN" }, { label: "TV" }, { label: "TS" }, { label: "UD" }, { label: "VA" }, { label: "VE" }, { label: "VB" }, { label: "VC" }, { label: "VR" }, { label: "VV" }, { label: "VI" }, { label: "VT" }];

provinceList.sort((a, b) => {
	if (a.label > b.label) {
		return 1;
	}
	else if (a.label < b.label) {
		return -1;
	}
});

Shark.set({
	agentAppURL,
	allowedUploadExtensionList: ["doc", "docx", "dwg", "gif", "heic", "hevc", "jfif", "jpg", "jpeg", "m2a", "m2v", "m4a", "m4v", "mp3", "mp4", "mpg", "mov", "ods", "odt", "pdf", "png", "ppt", "pptx", "rar", "rtf", "tif", "tiff", "txt", "xls", "xlsx", "zip"],
	appBuildDate: __BUILD_DATE__,
	appVersion: __VERSION__,
	clientActivityStatusList,
	clientActivityStatusMap,
	constructionSiteStatusList,
	constructionSiteStatusMap,
	constructionSiteCardStatusList,
	constructionSiteCardStatusMap,
	contactSourceList,
	contactSourceMap,
	contactSourceDetailList,
	contactSourceDetailMap,
	contactSourceDetailLabelMap,
	currencyFormatter: new Intl.NumberFormat("it-IT", { currency: "EUR", style: "currency"}),
	dtIsoDate: "YYYY-MM-DD",
	dateISODateTimeFormat: "YYYY-MM-DD HH:mm:ss",
	dateHumanFormat: "DD/MM/YYYY",
	dateTimeHumanFormat: "DD/MM/YYYY - HH:mm",
	dateISOFormat: "YYYY-MM-DD",
	extranetURL,
	followUpReferenceList,
	followUpReferenceMap,
	followUpTypeList,
	followUpTypeMap,
	fullClientList: [],
	interestedInList,
	interestedInMap,
	notComplianceReportInvoicingStatusList,
	notComplianceReportInvoicingStatusMap,
	notComplianceReportPaymentStatusList,
	notComplianceReportPaymentStatusMap,
	notComplianceReportStatusList,
	notComplianceReportStatusMap,
	provinceList,
	quotationStatusList,
	quotationStatusMap,
	reportStatusList,
	reportStatusMap,
	sectorList: [
		"Aereonautico",
		"Alimentare",
		"Arredo Urbano",
		"Artigiano",
		"Automotive",
		"Cartaria",
		"Chimico-Farmaceutico",
		"Comune o Regione",
		"Contract",
		"Edile",
		"Elettronico",
		"GDO",
		"Geodrena",
		"Green Paving",
		"Impresa Costruzioni",
		"Infrastrutture",
		"Logistica - Magazzini",
		"Manifatturiero",
		"Meccanico",
		"Navale",
		"Ospedaliero",
		"Parking",
		"Privato",
		"Studio Tecnico",
		"Tessile-Tintorie-Conciario",
		"Altro",
	],
	siteInfoSheetQuotationStatusList,
	siteInfoSheetQuotationStatusMap,
	systemIndustrialList,
	systemProposalGroupList,
	systemProposalGroupMap,
	timeISOFormat: "HH:mm:ss",
	timeShortFormat: "HH:mm",
	visitOutcomeList,
	visitOutcomeMap,
	visitStatusList,
	visitStatusMap,
	__cdnURL: serverURL
});

if (window.name === "") {
	window.name = Shark.__generateGUID();
}

var windowData = localStorage.getItem("win_" + window.name);

if (windowData) {
	windowData = JSON.parse(windowData);
}
else {
	windowData = {};
}

windowData.lastRefresh = new Date().getTime();
localStorage.setItem("win_" + window.name, JSON.stringify(windowData));

for (var item in localStorage) {
	if (item.substr(0, 4) === "win_") {
		var itemData = JSON.parse(localStorage.getItem(item));

		if (itemData.lastRefresh) {
			if (itemData.lastRefresh < new Date().getTime() - 86400000) {
				localStorage.removeItem(item);
			}
		}
		else {
			localStorage.removeItem(item);
		}
	}
}

//Dave: Questo va associato a "startUp()";
// Dave:ToDo:
systemManager.checkAppVersion();
	
if (localStorage.getItem("preserveLogin") === "true") {
	NousCore.api.validateSession()
	.then(response => {
		if (response.sessionIsValid) {
			NousCore.api.getSessionUser()
			.then(response => {
				if (response.userData) {
					Shark.set("currUser", Shark.getInstance("User", response.userData));
					let viewFound = false;
					let requestedPage = document.location.hash;
					requestedPage = requestedPage !== "" ? requestedPage.slice(1) : "";

					if (requestedPage !== "") {
						viewFound = Shark.openPage(requestedPage);
					}

					if (!viewFound) {
						Shark.openPage(homeView);
					}
				}
				else {
					Shark.openPage(loginView);
				}
			});
		}
		else {
			Shark.openPage(loginView);
		}
	});
}
else {
	Shark.openPage(loginView);
}

window.addEventListener("focus", () => systemManager.checkAppVersion());

//Dave.ToDo: Questo dovrebbe gestire il cambio di stickyness per quindi gestire l'opacità
// document.addEventListener('sticky-change', e => {
// 	const header = e.detail.target;  // header became sticky or stopped sticking.
// 	const sticking = e.detail.stuck; // true when header is sticky.
// 	header.classList.toggle('shadow', sticking); // add drop shadow when sticking.
  
// 	document.querySelector('.who-is-sticking').textContent = header.textContent;
//   });